import { FileGetDto, FileUploadResultDto } from "generated/CoreApi_v1";

export enum RequestLifeCycle {
    None,
    Init, InitSuccess, InitFailed,
    Loading, LoadFailed,
    Posting, PostSuccess, PostFailed,
    PermissionDenied,
    NoUserLicenses
}

export enum AttachType {
    Image,
    Video,
    Audio,
    Document
}

export enum ImageOrientation {
    Landscape,
    Portrait
}

export interface AsyncUploadModel {
    uploadId: string;
    success: boolean;
    mainFile: FileUploadResultDto;
    thumbnail: FileUploadResultDto;
}

export interface FileThumbnailPostDto {
    fileId: string;
    thumbnailId: string;
}

export interface FileThumbnaildGetDto {
    mainFile: FileGetDto;
    thumbnail: FileGetDto | null;
    resizedImage: FileGetDto | null;
}

export type PerformaSessionState = "init" | "newRelease" | "error" | "ready" | "checkAccess";